import { createSelector } from 'reselect'
import _ from 'underscore'

import arrayIntersection from 'modules/arrayIntersection'
import orderBy from 'modules/orderBy'
import dateFilter from 'modules/dateFilter'

import { FILTER_NONE, FILTER_HAS_VALUE } from 'Profiles/constants/filters'

export const getCustomerChildrenCompanies = state => state.customers.childrenCompanies
export const getChildrenCompaniesSort = state => state.customers.childrenCompaniesSort
export const getChildrenCompaniesSortField = state => state.customers.childrenCompaniesSort.field
export const getChildrenCompaniesSortDir = state => state.customers.childrenCompaniesSort.direction

export const getChildrenCompaniesFilters = state => state.customers.childrenCompaniesFilters
export const getChildrenCompaniesNameFilter = state => state.customers.childrenCompaniesFilters.name
export const getChildrenCompaniesUpdatedAtFilter = state => state.customers.childrenCompaniesFilters.updatedAt
export const getChildrenCompaniesOwnerFilter = state => state.customers.childrenCompaniesFilters.owner
export const getChildrenCompaniesValueFilter = state => state.customers.childrenCompaniesFilters.value

export const getChildrenCompaniesByName = createSelector(
  [getCustomerChildrenCompanies, getChildrenCompaniesNameFilter],
  (companies, nameFilter) => {
    if (!nameFilter.length) return companies
    return companies.filter(company => nameFilter.includes(company.id) || (nameFilter.includes(FILTER_NONE) && !company.id))
  }
)

export const getChildrenCompaniesByUpdatedAt = createSelector(
  [getCustomerChildrenCompanies, getChildrenCompaniesUpdatedAtFilter],
  (companies, updatedAtFilter) => dateFilter({ dateAttribute: 'updated_at', filter: updatedAtFilter, objects: companies })
)

export const getChildrenCompaniesByOwner = createSelector(
  [getCustomerChildrenCompanies, getChildrenCompaniesOwnerFilter],
  (companies, ownerFilter) => {
    if (!ownerFilter.length) return companies
    return companies.filter(company => ownerFilter.includes(company.owner_id) || (ownerFilter.includes(FILTER_NONE) && !company.owner_id))
  }
)

export const getChildrenCompaniesByValue = createSelector(
  [getCustomerChildrenCompanies, getChildrenCompaniesValueFilter],
  (companies, valueFilter) => {
    if (!Object.keys(valueFilter).length) return companies

    const withoutValue = (company) => (_.isNull(company.deals_value) || _.isUndefined(company.deals_value))
    const withValue = company => !withoutValue(company)

    if (valueFilter === FILTER_NONE) return companies.filter(withoutValue)
    if (valueFilter === FILTER_HAS_VALUE) return companies.filter(withValue)

    const fromValue = parseFloat(valueFilter.from)
    const toValue = parseFloat(valueFilter.to)
    return companies.filter(company => {
      const dealValue = parseFloat(company.deals_value)
      return (!fromValue || dealValue >= fromValue) && (!toValue || dealValue <= toValue)
    })
  }
)

export const getFilteredChildrenCompanies = createSelector(
  [getChildrenCompaniesByName, getChildrenCompaniesByUpdatedAt, getChildrenCompaniesByOwner, getChildrenCompaniesByValue, getChildrenCompaniesSortField, getChildrenCompaniesSortDir],
  (nameChildrenCompanies, updatedAtChildrenCompanies, ownerChildrenCompanies, valueCompanies, sortField, sortDir) => {
    return orderBy(
      arrayIntersection(nameChildrenCompanies, updatedAtChildrenCompanies, ownerChildrenCompanies, valueCompanies)
      , sortField, sortDir
    )
  }
)
